 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780718023676_COVER from '@/components/text/9780718023676_Cover'
 import TEXT9780718023676_TITLEPAGE from '@/components/text/9780718023676_Titlepage'
 import TEXT9780718023676_COPYRIGHT from '@/components/text/9780718023676_Copyright'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780718023676_BOOK_4DED from '@/components/text/9780718023676_Book_4ded'
 import TEXT9780718023676_BOOK_4GLO from '@/components/text/9780718023676_Book_4glo'
 import TEXT9780718023676_BOOK_4CH1 from '@/components/text/9780718023676_Book_4ch1'
 import TEXT9780718023676_BOOK_4CH2 from '@/components/text/9780718023676_Book_4ch2'
 import TEXT9780718023676_BOOK_4CH3 from '@/components/text/9780718023676_Book_4ch3'
 import TEXT9780718023676_BOOK_4CH4 from '@/components/text/9780718023676_Book_4ch4'
 import TEXT9780718023676_BOOK_4CH5 from '@/components/text/9780718023676_Book_4ch5'
 import TEXT9780718023676_BOOK_4CH6 from '@/components/text/9780718023676_Book_4ch6'
 import TEXT9780718023676_BOOK_4CH7 from '@/components/text/9780718023676_Book_4ch7'
 import TEXT9780718023676_BOOK_4CH8 from '@/components/text/9780718023676_Book_4ch8'
 import TEXT9780718023676_BOOK_4CH9 from '@/components/text/9780718023676_Book_4ch9'
 import TEXT9780718023676_BOOK_4BM1 from '@/components/text/9780718023676_Book_4bm1'
 import TEXT9780718023676_BOOK_4ACK from '@/components/text/9780718023676_Book_4ack'
 import TEXT9780718023676_RECIPES3 from '@/components/text/9780718023676_Recipes3'
 import TEXT9780718023676_RECIPES_SEC4 from '@/components/text/9780718023676_Recipes_sec4'
 import TEXT9780718023676_EXCERPT from '@/components/text/9780718023676_excerpt'
 import TEXT9780718023676_BOOK_1CH1 from '@/components/text/9780718023676_Book_1ch1'
 import TEXT9780718023676_BOOK_1CH2 from '@/components/text/9780718023676_Book_1ch2'
 import TEXT9780718023676_ALSO from '@/components/text/9780718023676_Also'
 import TEXT9780718023676_BOOK_4ATA from '@/components/text/9780718023676_Book_4ata'
 import TEXT9780718023676_BOOK_4BACK from '@/components/text/9780718023676_Book_4back'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780718023676_Book_4ded",
 			"name" : "text/9780718023676_Book_4ded",
 			"component" : TEXT9780718023676_BOOK_4DED
 		},
 		{
 			"path" : "/text/9780718023676_Book_4glo",
 			"name" : "text/9780718023676_Book_4glo",
 			"component" : TEXT9780718023676_BOOK_4GLO
 		},
 		{
 			"path" : "/text/9780718023676_Book_4ch1",
 			"name" : "text/9780718023676_Book_4ch1",
 			"component" : TEXT9780718023676_BOOK_4CH1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js